/**
 * @Author: luoob
 * @Date: 2021-10-28 16:03:35
 * @Last Modified by: luoob
 * @Last Modified time: 2021-10-28 16:03:41
 * @Instruduction: 在线协助服务接口
 */

import xhr from './xhr'

class OnlineService {
    /** 获取协助类型 */
    public getOrderType(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order/types',
            params: params
        })
    }
    /** 获取协助状态 */
    public getOrderStatus(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order/status',
            params: params
        })
    }
    /** 获取协助列表 */
    public getOrderList(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order/list',
            params: params
        })
    }
    /** 获取协助详情 */
    public getOrderDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order',
            params: params
        })
    }
    /** 修改协助 */
    public updateOrder(params: any) {
        return xhr({
            method: 'put',
            url: '/work_order',
            params: params
        })
    }
    /** 获取协助评论类型 */
    public getCommentType(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order/comment/types',
            params: params
        })
    }
    /** 获取协助评论列表 */
    public getCommentList(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order/comment/list',
            params: params
        })
    }
    /** 创建评论 */
    public createComment(params: any) {
        return xhr({
            method: 'post',
            url: '/work_order/comment',
            params: params
        })
    }
    /** 获取协助服务满意度 */
    public getSurveySatisfaction(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order/satisfaction/list',
            params: params
        })
    }
    /** 获取协助关闭原因 */
    public getCloseReason(params: any) {
        return xhr({
            method: 'get',
            url: '/work_order/reason/list',
            params: params
        })
    }
}
 
export default new OnlineService()
 